import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { sha256 } from 'js-sha256';

@Injectable({
  providedIn: 'root'
})
export class AesUtilService {
  public keySize:any;
  public iterationCount:any;
  
  constructor() {

  }

  AesUtil(keySize, iterationCount) {
    this.keySize = keySize / 32;
    this.iterationCount = iterationCount;
  }

  generateKey (salt, passPhrase) {
    var key = CryptoJS.PBKDF2(
      passPhrase,
      CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount
      });
    return key;
  }

  encrypt(salt, iv, passPhrase, plainText) {
    var key = this.generateKey(salt, passPhrase);
    //window.alert(key);
    var encrypted = CryptoJS.AES.encrypt(
      plainText,
      key, {
        iv: CryptoJS.enc.Hex.parse(iv)
      });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    
    
  }

 

  // decrypt2(passPhrase, cipherText) {
  //   var key = this.generateKey2( passPhrase);
  //   var cipherParams = CryptoJS.lib.CipherParams.create({
  //     ciphertext: CryptoJS.enc.Base64.parse(cipherText)
  //   });
  //   var decrypted = CryptoJS.AES.decrypt(
  //     cipherParams,
  //     key);
  //   return decrypted.toString(CryptoJS.enc.Utf8);
  // }

  


  // async hash(userid,password) {
  //   const utf8 = new TextEncoder().encode(userid);
  //   const hashBuffer = await crypto.subtle.digest('HmacSHA256', utf8);
  //   const hashArray = Array.from(new Uint8Array(hashBuffer));
  //   const hashHex = hashArray
  //     .map((bytes) => bytes.toString(16).padStart(2, '0'))
  //     .join('');
  //   return hashHex;
  // }
  
  decrypt(salt, iv, passPhrase, cipherText) {
    var key = this.generateKey(salt, passPhrase);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(cipherText)
    });
    var decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      key, {
        iv: CryptoJS.enc.Hex.parse(iv)
      });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  getSHA256(key,msg) {
    let chk=sha256.hmac(key, msg).toString();
    return chk;
  }

  encrypt_PassPhrase(encryptionCode,StringToEncrypt) {
    //var plaintext = plainText;
    var pwhash = CryptoJS.SHA1(CryptoJS.enc.Utf8.parse(StringToEncrypt));
    var key = CryptoJS.enc.Hex.parse(pwhash.toString(CryptoJS.enc.Hex).substr(0, 32));

    var encrypted = CryptoJS.AES.encrypt(encryptionCode, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)

  }
  
  decrypt_PassPhrase(cipherText,passPhrase) {
    var ciphertext = CryptoJS.enc.Base64.parse(cipherText);//CryptoJS.enc.Hex.parse(cipherText);
    var pwhash = CryptoJS.SHA1(CryptoJS.enc.Utf8.parse(passPhrase));
    var key = CryptoJS.enc.Hex.parse(pwhash.toString(CryptoJS.enc.Hex).substr(0, 32));
    var decrypted = CryptoJS.AES.decrypt({
        ciphertext: ciphertext
     }, key, {
        mode:     CryptoJS.mode.ECB,
        padding:  CryptoJS.pad.Pkcs7
    });

  
  // var words = decrypted["words"]
  //     words.map(function(index){
  //       if(words[index] < 0){
  //         return "";
  //       }
  //   })
    const result = decrypted["words"].filter(word => word > 0);
    
    if(result.length == decrypted["words"].length){
      return decrypted.toString(CryptoJS.enc.Utf8);
    }else{
      return "";
    }
  }
}
